module.exports = __webpack_public_path__ + "static/media/title_bg_5.72573433.png";